import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { embedUrl } from "@/lib/api";

export default function TrailerModal({ url, title, open, onClose }) {
  const src = embedUrl(url);
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-4xl border-border bg-ink p-2 sm:p-3" data-testid="trailer-modal">
        <DialogTitle className="sr-only">{title ? `${title} trailer` : "Trailer"}</DialogTitle>
        {src ? (
          <div className="aspect-video w-full overflow-hidden rounded-lg">
            <iframe
              src={`${src}?autoplay=1`}
              title={title ? `${title} trailer` : "Trailer"}
              className="h-full w-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        ) : (
          <p className="p-8 text-center text-cream/70">Trailer coming soon.</p>
        )}
      </DialogContent>
    </Dialog>
  );
}
